import type { FC } from 'preact/compat'
import type { FiltersComponentProps } from '@services/wordpress/wordpress.types'
import { Filters } from '../Filters'
import { Combobox } from '@components/ComboBoxes/Combobox'
import { ComboboxMultiSelect } from '@components/ComboBoxes/ComboboxMultiSelect'
import { FilterSearchBtn } from '../FilterSearchBtn'

export const FilterComponent: FC<FiltersComponentProps> = ({
  insurance_label,
  needs_label,
  state_label,
  specialties: specialty,
  states: statesFilters,
  insurance,
  disabled_features,
  optional_filter_props,
  filter_buttons_props,
}) => {
  return (
    <Filters
      specialties={specialty}
      states={statesFilters}
      insurance={insurance}
      disabled_features={disabled_features}
      optional_filter_props={optional_filter_props}
      filter_buttons_props={filter_buttons_props}
    >
      {({
        selectedItems,
        handleRedirectClick,
        selectLater,
        handleSelectLater,
        isMobile,
        insurance,
        specialty,
        statesFilters,
        handleOpenStates,
        handleOpenInsurance,
        handleOpenNeeds,
        handleGetSelectedInsurance,
        handleGetSelectedState,
        openInsurance,
        openNeeds,
        openStates,
        handleGetSelectedNeeds,
        errors
      }) => {
        return (
          <div class='flex flex-col lg:gap-6 w-full'>
            <div class='flex flex-col gap-4 lg:gap-6 md:mt-12'>
              <div class='flex justify-center xl:flex-row gap-4 md:gap-6 xl:gap-0 flex-col'>
                <div class='flex justify-center items-center lg:flex-row flex-col'>
                  <h2 class='text-base sm:text-2xl md:text-4xl mr-2'>
                    {state_label}
                  </h2>
                  <div class='mx-3 lg:my-0 my-3 flex items-center'>
                    <Combobox
                      handleOpenClick={handleOpenStates}
                      error={errors?.state}
                      open={openStates}
                      selectedItem={selectedItems?.state}
                      isMobile={isMobile}
                      data={
                        selectedItems?.insurance
                          ? statesFilters.map((_state) => {
                              const states = insurance.find(
                                (_insurance) =>
                                  _insurance.value ===
                                  selectedItems.insurance?.value
                              )?.states

                              const hasStates = states?.find(
                                (_s) =>
                                  _s.abbreviation?.toLowerCase() ===
                                  _state.abbreviation?.toLowerCase()
                              )
                              if (hasStates) {
                                return {
                                  ..._state,
                                  filtered: true
                                }
                              }
                              return _state
                            })
                          : statesFilters
                      }
                      placeholder={
                        filter_buttons_props?.[0]
                          ? `${filter_buttons_props[0].label}${filter_buttons_props[0].is_optional ? '' : '*'}`
                          : `your state`
                      }
                      handleGetSelectedItem={handleGetSelectedState}
                    />
                  </div>
                </div>
                <div class='flex justify-center items-center lg:flex-row flex-col lg:my-0'>
                  <h2 class='text-base sm:text-2xl md:text-4xl mr-2'>
                    {insurance_label}
                  </h2>
                  <div class='mx-3 lg:my-0 my-3 flex items-center'>
                    <Combobox
                      handleOpenClick={handleOpenInsurance}
                      error={errors?.insurance}
                      open={openInsurance}
                      selectedItem={selectedItems.insurance}
                      isMobile={isMobile}
                      data={
                        // find insurance with the selected state
                        selectedItems?.state
                          ? insurance.map((_insurance) => {
                              const insurerHasSelectedState =
                                _insurance.states?.find(
                                  (_s) =>
                                    _s.abbreviation?.toLowerCase() ===
                                    selectedItems.state?.abbreviation?.toLowerCase()
                                )

                              if (insurerHasSelectedState) {
                                return {
                                  ..._insurance,
                                  filtered: true
                                }
                              }
                              return _insurance
                            })
                          : insurance
                      }
                      placeholder={
                        filter_buttons_props?.[1]
                          ? `${filter_buttons_props[1].label}${filter_buttons_props[1].is_optional ? '' : '*'}`
                          : `your insurance`
                      }
                      handleGetSelectedItem={handleGetSelectedInsurance}
                    />
                  </div>
                </div>
              </div>
              <div class='flex justify-center items-center lg:flex-row flex-col'>
                <h2 class='text-base sm:text-2xl md:text-4xl mr-2'>
                  {needs_label}
                </h2>
                <div class='mx-3 lg:my-0 my-3'>
                  <ComboboxMultiSelect
                    isMobile={isMobile}
                    handleOpenClick={handleOpenNeeds}
                    open={openNeeds}
                    specialties={specialty}
                    placeholder={
                      filter_buttons_props?.[2]
                        ? `${filter_buttons_props[2].label}${filter_buttons_props[2].is_optional ? '' : '*'}`
                        : `your needs`
                    }
                    optional
                    handleGetSelectedItems={handleGetSelectedNeeds}
                    selectedItems={selectedItems?.specialty}
                    selectLater={selectLater}
                    handleSelectLater={handleSelectLater}
                  />
                </div>
              </div>
            </div>

            <div class='flex justify-center py-6 mt-3'>
              <FilterSearchBtn label='Search' onClick={handleRedirectClick} />
            </div>
          </div>
        )
      }}
    </Filters>
  )
}
